<template>
  <b-modal ref="limit-card-modal" @ok="limitCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.limits.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.driver"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="driverId"
          :state="isDriverIdValid"
          :options="driverOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.fuelTypeCode"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelTypeCode"
          :state="isFuelTypeCodeValid"
          :options="fuelTypeCodeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.limitType"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="limitType"
          :state="isLimitTypeValid"
          :options="limitTypeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.limitValue"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="100000"
          v-model="limitValue"
          :state="isLimitValueValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.cycle"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="limitCycle"
          :state="isCycleValid"
          :options="cycleOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>
      
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        locale="ua"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.beginTime"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="beginTime"
          :state="isBeginTimeValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        locale="ua"
        :label="$store.state.localization.data.mainPage.limits.tableColumns.endTime"
        label-for="input-horizontal"
      >
        <b-form-datepicker
          v-model="endTime"
          :state="isEndTimeValid"
          value-as-date="true"
          style="font-size: 13px"
          :locale="calendarLocale"
        ></b-form-datepicker>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { limitService, utilsService } from "../../../services";

export default {
  name: "CreateLimitPage",
  components: {},
  props: {
    drivers: Array,
  },
  data() {
    return {
      driverId: null,
      fuelTypeCode: null,
      limitType: null,
      limitValue: null,
      beginTime: null,
      endTime: null,
      limitCycle: null,
      isDriverIdValid: null,
      isLimitValueValid: null,
      isLimitTypeValid: null,
      isBeginTimeValid: null,
      isEndTimeValid: null,
      isCycleValid: null,
      isFuelTypeCodeValid: null
    };
  },
  computed: {
    cycleOptions() {
      const cycleOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.limits.cycleOptions.length;
        i++
      ) {
        cycleOptions.push({
          value:
            this.$store.state.localization.data.mainPage.limits.cycleOptions[i]
              .key,
          text: this.$store.state.localization.data.mainPage.limits
            .cycleOptions[i].value,
        });
      }
      return cycleOptions;
    },
    driverOptions() {
      const driversOptions = [];

      for (let i = 0; i < this.drivers.length; i++) {
        driversOptions.push({
          value: this.drivers[i].id,
          text: this.drivers[i].lastName + " " + this.drivers[i].firstName,
        });
      }
      return driversOptions;
    },
    fuelTypeCodeOptions() {
      const fuelTypeCodeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.common.fuelTypeCodeOptions.length;
        i++
      ) {
        fuelTypeCodeOptions.push({
          value:
            this.$store.state.localization.data.common.fuelTypeCodeOptions[i]
              .key,
          text: this.$store.state.localization.data.common.fuelTypeCodeOptions[
            i
          ].value,
        });
      }
      return fuelTypeCodeOptions;
    },
    limitTypeOptions() {
      const limitTypeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.limits.limitTypeOptions
          .length;
        i++
      ) {
        limitTypeOptions.push({
          value:
            this.$store.state.localization.data.mainPage.limits
              .limitTypeOptions[i].key,
          text: this.$store.state.localization.data.mainPage.limits
            .limitTypeOptions[i].value,
        });
      }
      return limitTypeOptions;
    },
    calendarLocale() {
      return utilsService.getCalendarLocale(this.$store.state.localization.locale);
    }
  },
  methods: {
    open() {
      this.fuelTypeCode = null;
      this.limitType = null;
      this.limitValue = null;
      this.beginTime = null;
      this.endTime = null;
      this.driverId = null;
      this.limitCycle = null;

      this.isDriverIdValid = null;
      this.isFuelTypeCodeValid = null;
      this.isLimitValueValid = null;
      this.isBeginTimeValid = null;
      this.isEndTimeValid = null;
      this.isCycleValid = null;
      this.isDriverIdValid = null;

      this.$refs["limit-card-modal"].show();
    },
    async limitCardModalOk(event) {
      const MIN_LIMIT_VALUE = 1;
      const MAX_LIMIT_VALUE = 10000;

      this.isDriverIdValid = null;
      this.isFuelTypeCodeValid = null;
      this.isLimitTypeValid = null;
      this.isLimitValueValid = null;
      this.isBeginTimeValid = null;
      this.isEndTimeValid = null;
      this.isCycleValid = null;

      if (!this.driverId) {
        this.isDriverIdValid = false;
        event.preventDefault();
        return;
      }

      if (!this.fuelTypeCode) {
        this.isFuelTypeCodeValid = false;
        event.preventDefault();
        return;
      }

      if (!this.limitType) {
        this.isLimitTypeValid = false;
        event.preventDefault();
        return;
      }

      if (!this.limitValue) {
        this.isLimitValueValid = false;
        event.preventDefault();
        return;
      } else {
        if (this.limitValue >= MAX_LIMIT_VALUE || this.limitValue < MIN_LIMIT_VALUE) {
          this.isLimitValueValid = false;
          event.preventDefault();
          return;
        }
      }

      if (!this.beginTime) {
        this.isBeginTimeValid = false;
        event.preventDefault();
        return;
      }

      if (!this.endTime) {
        this.isEndTimeValid = false;
        event.preventDefault();
        return;
      }

      if (this.beginTime > this.endTime) {
        this.isBeginTimeValid = false;
        event.preventDefault();
        return;
      }

      if (!this.limitCycle) {
        this.isCycleValid = false;
        event.preventDefault();
        return;
      }

      const limitCard = {
        driverId: parseInt(this.driverId),
        fuelTypeCode: this.fuelTypeCode,
        limitType: parseInt(this.limitType),
        limitValue: parseFloat(this.limitValue),
        beginTime: this.beginTime.getTime() / 1000,
        endTime: this.endTime.getTime() / 1000,
        limitCycle: parseInt(this.limitCycle),
        limitStatus: 0,
      };

      const createLimitResponse = await limitService.createLimit(limitCard);

      if (
        createLimitResponse.isSuccess &&
        createLimitResponse.data &&
        createLimitResponse.data.countInsertedRows != 0
      ) {
        this.$emit("limitCreatedSuccessEvent", limitCard);
      } else {
        this.$emit("limitCreatedFailEvent");
      }
    },
  },
};
</script>
